var map = {
	"./it_IT.json": 679
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 678;



/*****************
 ** WEBPACK FOOTER
 ** ./client/app/translations \.json$
 ** module id = 678
 ** module chunks = 0
 **/